module.exports = __webpack_public_path__ + "img/Simple Purple.014b62c1.jpg";